module.exports = __webpack_public_path__ + "img/email-icon.d3397119.svg";